export const timeSpanToMS = (timeSpan: string): number => {
    const tt = timeSpan.split(':');
    return (parseInt(tt[0]) * 3600 + parseInt(tt[1]) * 60 + parseInt(tt[2])) * 1000;
};

export const getDateForOffset = (date: Date, minuteOffset?: number): Date => {
    const local = new Date(date);
    local.setMinutes(local.getMinutes() + (minuteOffset ?? 0));
    return local;
};
